
import { _getStartEndColumns } from "./_getStartEndColumns";

export const _getItemsAfterThisWidgetInThisRow = ({
  widgetIndex: _widgetIndex,
  config,
  endCol: _endCol,
  TOTAL_COLUMNS,
}) => {
  let endCol = _endCol;
  let widgetIndex = _widgetIndex;
  const itemIndexes = [];
  if (endCol !== TOTAL_COLUMNS + 1) {
    while (endCol < TOTAL_COLUMNS + 1) {
      const nextItem = config[widgetIndex + 1];
      const [sC, eC] = _getStartEndColumns(nextItem.gridColumn);

      itemIndexes.push(widgetIndex + 1);
      endCol = eC;
      widgetIndex++;
    }
  }
  return itemIndexes;
};
